import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { useLocation } from "react-router";

import { Alert } from "antd";

import { useSessionStorage } from "utils/hooks";
import { BannerDetail } from "utils/types";
import { ALERT_TYPES } from 'utils/objects';

import { BannerProps } from "./Proptypes";

const Banner = (props: BannerProps) => {

  const location = useLocation();
  
  const storeBannerClosing  = (uid: number) => {
    let bannerKey = 'isBanner' + uid + 'Visible';
    sessionStorage.setItem(bannerKey, 'N');
  }

  return (
    <>
    {props.bannerDetails.map((banner: BannerDetail) => {   
        let bannerKey = 'isBanner' + banner.Uid + 'Visible';
        if ((!banner.IpaGroup || banner.IpaGroup === sessionStorage.getItem('ipaGroup'))
          && (!banner.PagePath || banner.PagePath === props.pagePath)
          && (sessionStorage.getItem(bannerKey) != 'N')
          && (ALERT_TYPES.includes(banner.Type!.toUpperCase()))) {  
            return <Alert
              message={<div dangerouslySetInnerHTML={{ __html: banner.BannerMessage }}/>}
              type={banner.Type}
              className="scheduled-maintenance-banner"
              banner
              closable
              onClose={() => storeBannerClosing(banner.Uid)}
            />;            
        }
      })}
    </>
  );
};

const mapStateToProps = (state: RootStateOrAny) => ({
  isSendingFeedback: state.rootReducer.app.isSendingFeedback,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
   
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Banner);